module.exports = __webpack_public_path__ + "img/nexultra-b-icon.fe5f5267.svg";